import React from 'react';
import { asCurrency } from '@ally/aos-utils';
import { Details, Term } from '../shared';
var AmountDisplay = function (_a) {
    var amount = _a.amount, distributionAmountType = _a.distributionAmountType;
    return (React.createElement(React.Fragment, null,
        React.createElement(Term, null, distributionAmountType ? 'Distribution amount' : 'Amount'),
        React.createElement(Details, null, asCurrency(amount))));
};
export default AmountDisplay;
//# sourceMappingURL=Display.js.map